import {
  LOAD_EXCH_MARKET_DATA,
  SET_EXCH_DATA,
  SET_EXCH_DETAIL,
  SET_EXCH_MARKET_DATA,
  SET_HEADER_COUNTS,
  SET_FEES_TOTAL_COST,
  SET_FEES_ORDER_SIDE,
} from '../actions/exchDataActions'
import ExchDataModel from '../../models/ExchDataModel'
import MarketModel from '../../models/MarketModel'

export interface ExchDataState {
  exchData: ExchDataModel[]
  exchDetail: ExchDataModel | false
  exchMarketData: MarketModel[]
  totalRecords: number
  headerCounts: any | false
  loadingMarketData: boolean
  totalCost: number
  orderSide: number
}

interface ExchDataAction {
  type: string
  exchData?: ExchDataModel[]
  exchDetail?: ExchDataModel
  exchMarketData?: MarketModel[]
  totalRecords?: number
  headerCounts?: any
  totalCost?: number
  orderSide?: number
}

const initialState: ExchDataState = {
  exchData: [],
  exchDetail: false,
  exchMarketData: [],
  totalRecords: 0,
  headerCounts: false,
  loadingMarketData: false,
  totalCost: 0,
  orderSide: 1,
}

const exchDataReducer = (state: ExchDataState = initialState, action: ExchDataAction): ExchDataState => {
  switch (action.type) {
    case SET_EXCH_DATA:
      return {
        ...state,
        exchData: action.exchData || [],
      }
    case SET_EXCH_DETAIL:
      return {
        ...state,
        exchDetail: action.exchDetail || false,
      }
    case LOAD_EXCH_MARKET_DATA:
      return {
        ...state,
        loadingMarketData: true,
      }
    case SET_EXCH_MARKET_DATA:
      return {
        ...state,
        loadingMarketData: false,
        exchMarketData: action.exchMarketData || [],
        totalRecords: action.totalRecords || 0,
      }
    case SET_HEADER_COUNTS:
      return {
        ...state,
        headerCounts: action.headerCounts || false,
      }
    case SET_FEES_TOTAL_COST:
      return {
        ...state,
        totalCost: action.totalCost || 0,
      }
    case SET_FEES_ORDER_SIDE:
      return {
        ...state,
        orderSide: action.orderSide || 1,
      }
    default:
      return state
  }
}

export default exchDataReducer 